var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25C6.07 23.25 1.25 18.43 1.25 12.5C1.25 6.57 6.07 1.75 12 1.75C17.93 1.75 22.75 6.57 22.75 12.5C22.75 18.43 17.93 23.25 12 23.25ZM12 3.25C6.9 3.25 2.75 7.4 2.75 12.5C2.75 17.6 6.9 21.75 12 21.75C17.1 21.75 21.25 17.6 21.25 12.5C21.25 7.4 17.1 3.25 12 3.25Z",
    fill: "#D61818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25C11.59 14.25 11.25 13.91 11.25 13.5V8.5C11.25 8.09 11.59 7.75 12 7.75C12.41 7.75 12.75 8.09 12.75 8.5V13.5C12.75 13.91 12.41 14.25 12 14.25Z",
    fill: "#D61818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4999C11.87 17.4999 11.74 17.4699 11.62 17.4199C11.5 17.3699 11.39 17.2999 11.29 17.2099C11.2 17.1099 11.13 17.0099 11.08 16.8799C11.03 16.7599 11 16.6299 11 16.4999C11 16.3699 11.03 16.2399 11.08 16.1199C11.13 15.9999 11.2 15.8899 11.29 15.7899C11.39 15.6999 11.5 15.6299 11.62 15.5799C11.86 15.4799 12.14 15.4799 12.38 15.5799C12.5 15.6299 12.61 15.6999 12.71 15.7899C12.8 15.8899 12.87 15.9999 12.92 16.1199C12.97 16.2399 13 16.3699 13 16.4999C13 16.6299 12.97 16.7599 12.92 16.8799C12.87 17.0099 12.8 17.1099 12.71 17.2099C12.61 17.2999 12.5 17.3699 12.38 17.4199C12.26 17.4699 12.13 17.4999 12 17.4999Z",
    fill: "#D61818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.9f80253ae8b7bc76fc4a74d5d650c94a.svg";
export { ForwardRef as ReactComponent };